import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress';
import styles from './Loader.module.scss';

function ProgressLoader (props) {
  return(
    <div className={styles['spinnerContainer']}>
      <div className={styles['spinner']}>
        <CircularProgress></CircularProgress>
      </div>
    </div>
  )
};

export default ProgressLoader;